import Vue from 'vue'
import App from './App.vue'
import './assets/main.css'
import router from '@/router/index'
import { createPinia, PiniaVuePlugin } from 'pinia'
import ECharts from 'vue-echarts'
import "echarts";
Vue.component('VueEcharts', ECharts)
Vue.use(PiniaVuePlugin)
Vue.config.productionTip = false
const pinia = createPinia()
new Vue({
  router,
  pinia,
  render: h => h(App),
}).$mount('#app')
